import { secondAxios } from "../../../../api/axios";

export const getCompanyVendors = async (type) => {
  const getCompanyVendorsApi = `/${type}`;
  const { data } = await secondAxios.get(getCompanyVendorsApi);
  return data;
};

export const addNewVendor = async (companyId, vendor, type) => {
  const addVendorsApi = `/${type}/add-${type}s`;
  const { data } = await secondAxios.post(addVendorsApi, [vendor]);
  return data;
};

export const editVendor = async (id, vendorData, type) => {
  const editVendorApi = `/${type}/` + id;
  const { data } = await secondAxios.post(editVendorApi, vendorData);

  console.log({ data });
  return data;
};

export const deleteVendor = async (vendorId, type) => {
  const deleteVendorApi = `/${type}/` + vendorId;

  const { data } = await secondAxios.delete(deleteVendorApi);
  return data;
};
